import loadable from '@loadable/component';

export const UnpublishedVolopPageLoadable = loadable(
  () => import('./UnpublishedVolopPage'),
  { resolveComponent: (module) => module.UnpublishedVolopPage },
);
